import axiosConfig from '../../../../../config/axiosConfig';
import { Params } from '../../presenter/type/Presenter';

const CM0017_3_2Api = () => {
    const getReSummarySubmittedCompanyOutsourceCostOffsetList = async (
        params: Params,
    ): Promise<any> => {
        try {
            const url = '/re-summary/submitted/company/outsource-cost/offset/list';
            const response = await axiosConfig.get(url, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    return {
        getReSummarySubmittedCompanyOutsourceCostOffsetList,
    };
};

export default CM0017_3_2Api;
